import React, { useCallback, useMemo, useState } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useUser } from '@edwin/react-sdk'

import { AMarkdown } from '../atoms/AMarkdown'
import { MChatModal } from './MChatModal'
import { OInnerImageZoom } from '../organisms/OInnerImageZoom'

_.templateSettings.interpolate = /{{([\s\S]+?)}}/g

export const MChatInfographicIllustration = ({ illustrationFileName, descriptionMarkdown }) => {
  const { user, assistant } = useUser()
  const [isOpen, setIsOpen] = useState(false)

  const closeModal = useCallback(() => {
    setIsOpen(false)
  }, [setIsOpen])

  const openModal = useCallback(() => {
    setIsOpen(true)
  }, [setIsOpen])

  const isPossibleToZoom = useMemo(() => {
    return illustrationFileName.slice(-4) !== '.gif'
  }, [illustrationFileName])

  return (
    <div className="flex flex-col lg:w-auto">
      {illustrationFileName?.includes('https://') && (
        <img
          onClick={isPossibleToZoom ? openModal : null}
          src={illustrationFileName}
          className={classNames('w-full h-full object-cover', isPossibleToZoom && 'cursor-pointer')}
          alt="Illustration"
        />
      )}
      <div className="py-3 px-3.5">
        <AMarkdown paragraphStyles="text-sm">
          {_.template(descriptionMarkdown)({ user, assistant, input: assistant })}
        </AMarkdown>
      </div>
      {isPossibleToZoom && (
        <MChatModal isOpen={isOpen} onClose={closeModal}>
          <OInnerImageZoom src={illustrationFileName} onClose={closeModal} />
        </MChatModal>
      )}
    </div>
  )
}

MChatInfographicIllustration.propTypes = {
  descriptionMarkdown: PropTypes.string,
  illustrationFileName: PropTypes.string,
}
